/* eslint-disable react/jsx-no-comment-textnodes */

import { motion } from 'framer-motion';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import Transitions from '../../../components/Transition';

import AppHeader from '../../../components/AppHeader';
import Loader from '../../../components/Loader';
import MyModal from '../../../components/Modal';
import NoData from '../../../components/NoData';
import Sidebar from '../../../components/Sidebar';

import EvolutionVtAffreightmentCard from './components/DashboardCards/evolutionVtAffreightmentCard';
import LinesCard from './components/DashboardCards/linesCard';
import LinesPerformanceCard from './components/DashboardCards/linesPerformanceCard';
import OfferCard from './components/DashboardCards/offerCard';
import UserCostCard from './components/DashboardCards/userCostCard';
import UserProfileCard from './components/DashboardCards/userProfileCard';
import VtUsageCard from './components/DashboardCards/vtUsageCard';
import WarningsCard from './components/DashboardCards/warningsCard';

import FilterRadioButton from '../../../components/FilterRadioButtons';
import { SecondaryButton } from '../../../components/SecondaryButton';
import WorkplacesRadioButtons from '../../../components/WorkplacesRadioButtons';
import { MonthsGrid } from './components/DashboardCards/styles';
import useDashboard from './useDashboard';

export default function Dashboard() {
  const {
    userProfile,
    companyCode,
    doesWorkplacesListExists,
    apiWorkplacesFetched,
    isLoading,
    selectedWorkplace,
    apiDashboardFetched,
    dashboardOfferData,
    dashboardUserCostData,
    dashboardLinesData,
    dashboardWarningsData,
    filterWarningsByMonth,
    dashboardVtUsageData,
    dashboardUserProfileData,
    dashboardAffreightmentEvolutionData,
    dashboardVtEvolutionData,
    dashboardLinesPerformanceData,
    filterLinesPerformanceByDate,
    isWarningsFilterLoading,
    isLinesPerformanceFilterLoading,
    workplaces,
    handleWorkplaceChange,
    handleTryGetWorkplacesAgain,
    isWorkplacesLoading,
    startDate,
    selectStartDateModalShow,
    setSelectedStartYear,
    setSelectedStartMonth,
    selectedStartYear,
    selectedStartMonth,
    chooseStartDate,
    setSelectStartDateModalShow,
  } = useDashboard();

  const isEmpresaSelected = !!companyCode;
  const isAnyLocTrabSelected = (!!selectedWorkplace.label)
  && (apiDashboardFetched && doesWorkplacesListExists && !isLoading);
  const isServiceAlredyStarted = (!!startDate.month && !!startDate.year);
  const currentDate = new Date().toJSON().slice(0, 10);
  const currentYear = currentDate.split('-')[0];
  const currentMonth = currentDate.split('-')[1];
  const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const monthsMap: { [key: number]: string } = {
    1: 'Janeiro',
    2: 'Fevereiro',
    3: 'Março',
    4: 'Abril',
    5: 'Maio',
    6: 'Junho',
    7: 'Julho',
    8: 'Agosto',
    9: 'Setembro',
    10: 'Outubro',
    11: 'Novembro',
    12: 'Dezembro',
  };
  const isCaptaUser = (userProfile !== 10 && userProfile !== 11 && userProfile !== 12);

  return (
    <>
      <AppHeader isCompanySelectedDisabled={false} />
      <Sidebar active="Dashboard" />
      <Transitions>
        <Loader
          isLoading={
            isLoading || isWarningsFilterLoading || isLinesPerformanceFilterLoading
          }
        />

        {isEmpresaSelected && isServiceAlredyStarted && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.05, type: 'tween', stiffness: 10 }}
              className="dashboardHeader"
            >
              <WorkplacesRadioButtons
                isLoading={isWorkplacesLoading}
                doesWorkplacesListExists={doesWorkplacesListExists}
                apiWorkplaceFetched={apiWorkplacesFetched}
                handleWorkplaceChange={handleWorkplaceChange}
                handleTryGetWorkplacesAgain={handleTryGetWorkplacesAgain}
                selectedWorkplace={selectedWorkplace}
                workplaces={workplaces}
                showAllButton
              />
              <div>
                Serviço iniciado em
                {' '}
                {`${monthsMap[Number(startDate.month)]} de ${startDate.year}`}
              </div>
            </motion.div>

            {(isAnyLocTrabSelected && !isLoading) && (
              <Container>
                <Row xs={1} md={4} lg={5}>
                  {/* oferta */}
                  <Col>
                    <motion.div
                      initial={{ opacity: 0 }}
                      whileInView={{ opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.15, type: 'tween', stiffness: 10000 }}
                    >
                      <OfferCard
                        dashboardOfferData={dashboardOfferData}
                        selectedWorkplace={selectedWorkplace}
                      />
                    </motion.div>
                  </Col>

                  {/* custoUsuario */}
                  <Col>
                    <motion.div
                      initial={{ opacity: 0 }}
                      whileInView={{ opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.3, type: 'tween', stiffness: 10000 }}
                    >
                      <UserCostCard
                        dashboardUserCostData={dashboardUserCostData}
                        selectedWorkplace={selectedWorkplace}
                      />
                    </motion.div>
                  </Col>

                  {/* linhas */}
                  <Col>
                    <motion.div
                      initial={{ opacity: 0 }}
                      whileInView={{ opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.45, type: 'tween', stiffness: 10000 }}
                    >
                      <LinesCard
                        dashboardLinesData={dashboardLinesData}
                        selectedWorkplace={selectedWorkplace}
                      />
                    </motion.div>
                  </Col>

                  {/* advertencias */}
                  <Col>
                    <motion.div
                      initial={{ opacity: 0 }}
                      whileInView={{ opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.6, type: 'tween', stiffness: 10000 }}
                    >
                      <WarningsCard
                        dashboardWarningsData={dashboardWarningsData}
                        selectedWorkplace={selectedWorkplace}
                        onFilteringByMonth={filterWarningsByMonth}
                      />
                    </motion.div>
                  </Col>

                  {/* usam vt */}
                  <Col>
                    <motion.div
                      initial={{ opacity: 0 }}
                      whileInView={{ opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.75, type: 'tween', stiffness: 10000 }}
                    >
                      <VtUsageCard
                        dashboardVtUsageData={dashboardVtUsageData}
                        selectedWorkplace={selectedWorkplace}
                      />
                    </motion.div>
                  </Col>
                </Row>

                <Row xs={1} md={2} lg={2}>
                  {/* grafico pizza PERFIL USU */}
                  <Col>
                    <motion.div
                      initial={{ opacity: 0 }}
                      whileInView={{ opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.9, type: 'tween', stiffness: 10000 }}
                    >
                      <UserProfileCard
                        dashboardUserProfileData={dashboardUserProfileData}
                        selectedWorkplace={selectedWorkplace}
                      />
                    </motion.div>
                  </Col>

                  {/* grafico linhas EVOLUCAO VT X FRETA */}
                  <Col>
                    <motion.div
                      initial={{ opacity: 0 }}
                      whileInView={{ opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: 1.05, type: 'tween', stiffness: 10000 }}
                    >
                      <EvolutionVtAffreightmentCard
                        dashboardVtEvolutionData={dashboardVtEvolutionData}
                        dashboardAffreightmentEvolutionData={dashboardAffreightmentEvolutionData}
                        selectedWorkplace={selectedWorkplace}
                      />
                    </motion.div>
                  </Col>
                </Row>

                <Row xs={1} md={1} lg={1}>
                  {/* linhas performance */}
                  <Col>
                    <motion.div
                      initial={{ opacity: 0 }}
                      whileInView={{ opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{ delay: 0.1, type: 'tween', stiffness: 10000 }}
                    >
                      <LinesPerformanceCard
                        dashboardLinesPerformanceData={dashboardLinesPerformanceData}
                        onFilteringByDate={filterLinesPerformanceByDate}
                        selectedWorkplace={selectedWorkplace}
                      />
                    </motion.div>
                  </Col>
                </Row>
              </Container>
            )}
          </>
        )}

        {(!isEmpresaSelected) && (
          <NoData
            icon="companyInterrogation"
            label={(
              <>
              Selecione uma empresa para visualizar o dashboard.
              </>
            )}
          />
        )}

        {(isEmpresaSelected && !isServiceAlredyStarted && !isCaptaUser) && (
          <NoData
            icon="waitSettings"
            label={(
              <>
              O serviço ainda não foi configurado.
              Por favor, aguarde até que a configuração seja concluída pela Capta!
              </>
            )}
          />
        )}

        {(isEmpresaSelected && !isServiceAlredyStarted && isCaptaUser) && (
          <NoData
            icon="waitSettings"
            label={(
              <>
                <div>
                Informe a data de início do serviço de fretamento
                para exibir os dados do dashboard clicando no botão
                </div>
                <SecondaryButton onClick={() => setSelectStartDateModalShow(true)}>
                Informar data de início
                </SecondaryButton>
              </>
            )}
          />
        )}

        <MyModal
          show={selectStartDateModalShow}
          type="action"
          title="Selecionar data de início"
          modalBody={(
            <div className="modal-body-centered">
              <div className="year-selection">
                <FilterRadioButton
                  onClick={() => {
                    setSelectedStartYear(Number(currentYear) - 1);
                    setSelectedStartMonth('');
                  }}
                  selected={selectedStartYear == Number(currentYear) - 1}
                >
                  {String(Number(currentYear) - 1)}
                </FilterRadioButton>
                <FilterRadioButton
                  onClick={() => {
                    setSelectedStartYear(Number(currentYear));
                    setSelectedStartMonth('');
                  }}
                  selected={selectedStartYear == Number(currentYear)}
                >
                  {currentYear}
                </FilterRadioButton>
              </div>
              <MonthsGrid>
                {months.map((month) => (
                  <FilterRadioButton
                    key={month}
                    onClick={() => setSelectedStartMonth(month)}
                    selected={month == selectedStartMonth}
                    invisible={
                      Number(`${selectedStartYear}${month}`)
                      > Number(`${currentYear}${currentMonth}`)
                    }
                  >
                    {monthsMap[month]}
                  </FilterRadioButton>
                ))}
              </MonthsGrid>
            </div>
          )}
          size="lg"
          onAction={chooseStartDate}
          onClose={() => setSelectStartDateModalShow(false)}
          isActionButtonDisabled={!selectedStartMonth || !selectedStartYear}
          actionButtonLabel="Definir data de início"
          closeButtonLabel="Cancelar"
        />

      </Transitions>
    </>
  );
}
